import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Radium from 'radium'
import propTypeSchema, { getComponentSchema } from 'react-json-schema-proptypes'
import DonationButtons from '../common/donation-buttons.jsx'
import ProjectSelector from '../common/project-selector.jsx'
import { Amount, Typography, Project } from '../types'
import { assetUrl, valueOrUndefined } from '../common'

const schema = {
  'type': 'object',
  'required': ['buttons'],
  'properties': {
    'type': {'enum': ['alpha']},
    'buttons': DonationButtons.propSchema,
    'amounts': {'type': 'array', 'items': Amount.Schema},
    'projectSelector': ProjectSelector.propSchema,
    'displayMonthly': {'type': 'boolean'},
    'monthlyGiftBanner': {'type': 'string'},
    'monthlyGiftStyle': Typography.Schema,
    'mobileBreakPoint': {'type': 'number'},
    'mobileMaxWidth': {'type': 'number'},
    'showProjectSelector': {'type': 'boolean'},
    'projectSelectorLabel': {'type': 'string'},
    'projectSelectorLabelStyle': Typography.Schema
  }
}

@Radium
export default class AlphaGiftInfo extends React.PureComponent {
  static propSchema = schema

  static propTypes = propTypeSchema(schema, {
    'required': ['onAmountChanged', 'onProjectChanged', 'assetLoader', 'onValidChanged', 'onProjectMetadataChanged'],
    'properties': {
      'projects': {'type': 'array', 'items': Project.Schema},
      'projectSelector': getComponentSchema(ProjectSelector),
      'projectMetadata': {'type': 'object'},
      'amount': Amount.Schema,
      'displayErrors': {'type': 'boolean'},
      'selectedProject': Project.Schema,
      'onAmountChanged': {'isFunction': true},
      'onProjectChanged': {'isFunction': true},
      'onValidChanged': {'isFunction': true},
      'onProjectMetadataChanged': {'isFunction': true},
      'assetLoader': {'isFunction': true}
    }
  })

  static defaultProps = {
    displayMonthly: true,
    monthlyGiftBanner: 'donate-monthly.png',
    mobileBreakPoint: 768,
    mobileMaxWidth: 900,
    projectSelectorLabel: 'My gift will support:'
  }

  constructor (props) {
    super(props)
    this.state = {
      monthlyChecked: undefined,
      monthlyDisabled: false,
      amount: null,
      metadataHasError: false,
      projectHasError: false,
      buttonsError: false
    }
  }

  handleButtonChange = (newAmount) => {
    this.setState({
      amount: newAmount,
      ...(newAmount ? {
        monthlyDisabled: newAmount.frequency === 'monthly',
        monthlyChecked: newAmount.frequency && newAmount.frequency === 'monthly'
      } : {})
    }, () => this.props.onAmountChanged(newAmount))
  }

  handleButtonValidChange = (valid) => {
    this.setState({
      buttonsError: !valid
    }, () => {
      this.props.onValidChanged(this.allValid())
    })
  }

  projectChanged = (newProject, hasError) => {
    this.props.onProjectChanged(newProject)
    this.props.onProjectMetadataChanged({})
    this.setState({
      projectHasError: hasError,
      metadataHasError: !!newProject.hasQuestion
    }, () => {
      this.props.onValidChanged(this.allValid())
    })
  }

  metadataChanged = (label, value, hasError) => {
    this.props.onProjectMetadataChanged({[label]: value})
    this.setState({
      metadataHasError: hasError
    }, () => {
      this.props.onValidChanged(this.allValid())
    })
  }

  allValid = () => {
    return !this.state.projectHasError && !this.state.metadataHasError && !this.state.buttonsError
  }

  monthlyClicked = (e) => {
    this.setState({
      monthlyChecked: e.target.checked
    }, () => {
      if (this.state.amount) {
        this.props.onAmountChanged({
          ...this.state.amount,
          'frequency': this.state.monthlyChecked ? 'monthly' : 'one-time'
        })
      }
    })
  }

  render () {
    const styles = {
      monthlyBanner: {
        backgroundImage: `url(${this.props.assetLoader(this.props.monthlyGiftBanner)})`
      },
      checked: {
        backgroundImage: `url(${assetUrl('checkmark.png')}`
      },
      selectorMessage: valueOrUndefined(this.props, 'projectSelectorLabelStyle'),
      breakPointStyle: {}
    }
    if (this.props.mobileMaxWidth) {
      styles['breakPointStyle'][`@media (max-width: ${this.props.mobileBreakPoint - 1}px)`] = {
        maxWidth: this.props.mobileMaxWidth,
        marginLeft: "auto",
        marginRight: "auto"
      }
    }
    return (
      <div className='alpha' style={[styles.breakPointStyle]}>
        <DonationButtons amount={this.props.amount}
                         displayErrors={this.props.displayErrors}
                         onAmountChanged={this.handleButtonChange} onValidChanged={this.handleButtonValidChange}
                         amounts={this.props.amounts} {...this.props.buttons} />
        {this.props.displayMonthly &&
        <div>
          <Row>
            <Col xs={12}>
              <div className='monthly-gift' style={[styles.monthlyBanner]} />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className='monthly-check' style={[this.props.monthlyGiftStyle]}>
                <input name='monthly' id='monthly' type='checkbox' onChange={this.monthlyClicked}
                       checked={this.state.monthlyChecked} disabled={this.state.monthlyDisabled} />
                <label htmlFor='monthly' style={this.state.monthlyChecked ? [styles.checked] : []} /><span
                className='checkbox'>Make my gift monthly!</span>
              </div>
            </Col>
          </Row>
        </div>
        }
        {this.props.projects && this.props.projects.length > 0 && this.props.showProjectSelector &&
        <div>
          <div className={'selectorMessage'} style={[styles.selectorMessage]}>{this.props.projectSelectorLabel}</div>
          <ProjectSelector selectedProject={this.props.selectedProject} projects={this.props.projects}
                           onChange={this.projectChanged} onChangeMetadata={this.metadataChanged}
                           displayErrors={this.props.displayErrors} currentMetadata={this.props.projectMetadata}
                           {...this.props.projectSelector} />
        </div>
        }
      </ div>
    )
  }
}

